import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/estoque/baixaManual' };
/////////////////////////////////////////////////////////////////////////////////

export function createBaixaManualEstoque(payload) {
  return httpService.post(args, payload);
}

export function updateBaixaManualEstoque(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listBaixaManualEstoque(param) {
  return httpService.get({ ...args, args: param });
}

export function findBaixaManualEstoque(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllBaixaManualEstoque() {
  return httpService.get({ ...args, path: '/estoque/baixaManual/all' });
}

export function deleteBaixaManualEstoque(id) {
  return httpService.del({ ...args, args: `/${id}` });
}
